<template>
  <full-screen-modal>
    <div class="content">
      <div class="header">
        <div class="header-text">
          Tworzenie lekcji
        </div>
        <custom-icon-button
          button-name="close-edit-event-modal"
          class="icon"
          icon-name="times"
          @closeEditEventModalButton="$emit('close-edit-event-modal')"
        />
      </div>
      <EditEventForm
        :eventData="eventData"
        :times="times"
        @closeEditEventModal="$emit('close-edit-event-modal')"
      />
    </div>
  </full-screen-modal>
</template>

<script>
import CustomIconButton from '../common/CustomIconButton.vue';
import EditEventForm from '../form/EditEventForm.vue';
import FullScreenModal from './FullScreenModal.vue';

export default {
  name: 'EditEventModal',
  components: { FullScreenModal, EditEventForm, CustomIconButton },
  emits: ['close-edit-event-modal'],
  props: {
    eventData: Object,
    times: Object,
  },
};
</script>

<style lang="scss" scoped>
@import '../../assets/css/colors.scss';

.content {
  display: flex;
  flex-direction: column;
  margin: 20px;
  width: 100%;

  .header {
    border-bottom: 1px solid $grey;
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
    padding-bottom: 10px;

    .header-text {
      display: flex;
      flex-direction: column;
      justify-content: left;
    }

    .icon {
      border: none;
      color: $grey;
      cursor: pointer;
      height: 20px;
      padding: 0;
      width: 20px;
    }
  }
}
</style>
